<template>
    <div>
        <div>
            <!-- Texts -->
            <div class="grid grid-cols-2" v-for="(configuration, idx) in textConfigurations" :key="idx">
                <!-- Text line options -->
                <div class="col-span-2 flex mb-1"><strong>Textzeile {{ idx + 1 }}</strong></div>
                <div class="col-span-2 flex mb-3">
                    <div class="flex-grow mr-5">
                        <input type="text"
                            placeholder="Hier deinen Text eingeben"
                            maxlength="50"
                            class="w-full"
                            v-model="configuration.text"
                            @input="runTextPipeline()">
                    </div>
                    <div class="text-trash">
                        <i class="icon-trash cursor-pointer" @click="removeTextLine(idx)"></i>
                    </div>
                </div>

                <div class="mr-3 mt-5">
                    <SelectBox name="font" class="w-full" v-model="configuration.fontFamily" @change="runTextPipeline()">
                        <option :selected="configuration.fontFamily === 'Prata'">Prata</option>
                        <option :selected="configuration.fontFamily === 'Abril Fatface'">Abril Fatface</option>
                        <option :selected="configuration.fontFamily === 'Bellisia'">Bellisia</option>
                        <option :selected="configuration.fontFamily === 'Testimonia'">Testimonia</option>
                        <option :selected="configuration.fontFamily === 'Dancing Script'">Dancing Script</option>
                        <option :selected="configuration.fontFamily === 'Lato'">Lato</option>
                        <option :selected="configuration.fontFamily === 'Forum'">Forum</option>
                    </SelectBox>
                </div>

                <!-- <div>
                    <ColorPicker name="fill" v-model="configuration.fill"
                        @change="runTextPipeline()"></ColorPicker>
                </div> -->
                <div class="">
                    <div class="label">Textgröße</div>
                    <Slider
                        ref="textSizeSlider"
                        min="0.3"
                        max="3"
                        step="0.1"
                        v-model="configuration.scaleX"
                        @change="changeSize(idx, configuration.scaleX)"
                    ></Slider>
                </div>

                <hr class="col-span-2 border-b mb-5 bg-gray-400" v-if="idx !== textConfigurations.length-1">
            </div>
        </div>


        <div class="mt-3" v-if="backgroundType == 'image'">
            <hr class="col-span-2 border-b mb-5 bg-gray-400">
            <div class="mt-1 form-element">
                <div class="label">Textfarbe</div>
                <ColorPicker name="color"
                    :value="textColor"
                    @change="setTextColor($event)"
                ></ColorPicker>
            </div>
        </div>

        <div class="mt-3" v-if="textConfigurations.length == 0">
            <button class="btn" type="button" @click="addTextLine()">Textzeile hinzufügen</button>
        </div>

        <div class="mt-3" v-else-if="textConfigurations.length < 5">
            <button class="btn" type="button" @click="addTextLine()">Weitere Textzeile hinzufügen</button>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Slider from '~/scripts/Components/Slider.vue';
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import Defaults from '~/scripts/Pipeline/_defaults.js';
import SelectBox from "~/scripts/Components/SelectBox.vue";
import ColorPicker from "~/scripts/Components/ColorPicker.vue";

export default {
    components: {
        Slider,
        SelectBox,
        ColorPicker
    },
    data() {
        return {
            textConfigurations: []
        }
    },

    computed: {
        ...mapFields({
            color: 'stageConfiguration.color',
            backgroundType: 'stageConfiguration.background.type',
            customTextColor: 'stageConfiguration.customTextColor'
        }),

        textColor() {
            return this.customTextColor ?? this.color;
        }
    },

    mounted() {
        this.textConfigurations = JSON.parse(JSON.stringify(this.$store.state.textConfigurations));

        if (this.textConfigurations.length == 0) {
            const stageWidth = this.$store.state.stage.width();
            const stageHeight = this.$store.state.stage.height();
            // const defaultTextPositions = ['Kopfzeile', 'Widmung', 'Name'];
            const defaultTextPositions = ['Widmung'];

            for (let i = 0; i < defaultTextPositions.length; i++) {
                let fontFamily = this.$store.state.stageConfiguration.fontFamily;
                let y = parseInt(stageHeight * 0.075);
                const position = defaultTextPositions[i];
                const defaultConfig = JSON.parse(JSON.stringify(Defaults.textConfiguration));

                switch (position) {
                    case 'Name':
                        y = parseInt(stageHeight * 0.79) + 50;
                        fontFamily = 'Forum';
                        break;

                    case 'Widmung':
                        // scale = 2.08;
                        // y = parseInt(stageHeight * 0.79);
                        // fontFamily = 'Dancing Script';
                        break;

                    default:
                        break;
                }

                this.textConfigurations.push({
                    ...defaultConfig,
                    label: position,
                    x: (stageWidth / 2),
                    fontFamily: fontFamily,
                    fill: this.$store.state.stageConfiguration.color,
                });
            }
        }

        document.getElementById('ayv-container').addEventListener('textScaleChanged', (event) => {
            if (event.detail && event.detail.idx) {
                const idx = event.detail.idx;
                const textConfiguration = event.detail.textConfiguration;
                this.$refs.textSizeSlider[idx].set(textConfiguration.scaleX);
            }
        });
    },

    methods: {
        addTextLine() {
            let textConfigurations = JSON.parse(JSON.stringify(this.$store.state.textConfigurations));
            let newLine = JSON.parse(JSON.stringify(Defaults.textConfiguration));
            newLine.fontFamily = this.$store.state.stageConfiguration.fontFamily;
            let latestConfig = textConfigurations[Object.keys(textConfigurations)[Object.keys(textConfigurations).length - 1]];
            if (latestConfig) {
                newLine.scaleX = latestConfig.scaleX;
                newLine.scaleY = latestConfig.scaleY;
                newLine.y = latestConfig.y + 20;
                newLine.fontFamily = latestConfig.fontFamily;
            }

            newLine.fill = this.textColor;
            textConfigurations.push(newLine);

            this.textConfigurations = textConfigurations;

            this.runTextPipeline();
        },

        removeTextLine(idx) {
            let textConfigurations = JSON.parse(JSON.stringify(this.textConfigurations));

            textConfigurations.splice(idx, 1);

            this.textConfigurations = textConfigurations;

            this.runTextPipeline();
        },

        updateStore(value) {
            this.$store.commit('updateField', {
                path: 'textConfigurations',
                value: value
            });
        },

        runTextPipeline() {
            this.textConfigurations.forEach((textConfiguration, idx) => {
                this.textConfigurations[idx].fill = this.textColor;
            });

            this.updateStore(this.textConfigurations);

            return Pipeline.runTextPipeline();
        },

        changeSize(idx, scaleX) {
            this.textConfigurations[idx].scaleY = scaleX;
            this.updateStore(this.textConfigurations);

            return Pipeline.runTextPipeline();
        },

        setTextColor(textColor) {
            this.$store.commit('updateField', {
                path: 'stageConfiguration.customTextColor',
                value: textColor
            });
            Pipeline.updateTextColors(textColor, false);
        }
    }
};
</script>
